import { useSession } from "@src/appV2/Auth/api/useSession";
import { canSetRates } from "@src/appV2/ExperimentalHomeHealth/lib/rateConfigurationUtils";

export function useCanSetRates(): boolean {
  const session = useSession();
  return canSetRates(session);
}
